import { render } from "./DrawerView.vue?vue&type=template&id=27bfd026"
import script from "./DrawerView.vue?vue&type=script&lang=js"
export * from "./DrawerView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__